import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { serializeFilters } from '@user/components/Filters'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { LeadFilterSet } from '../filters'
import { setLeadFilters } from '../slice'
import { ILead } from '../typings'
import { useSelector } from 'react-redux'

export const useSaveLeadFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const leadPref = useMemo(() => prefs.find((p) => p.type === 'lead'), [prefs])

  return useCallback(
    (model: LeadFilterSet) => {
      dispatch(
        saveFilterPreference({
          id: leadPref?.id,
          type: 'lead',
          name: 'lead filters',
          filter: serializeFilters<ILead, LeadFilterSet>(model),
        }),
      )
      dispatch(setLeadFilters(model))
    },
    [dispatch, leadPref?.id],
  )
}
